module.exports = __webpack_public_path__ + "img/Pl-studio.396f4ccb.gif";